export default "__VITE_ASSET__CNvm07Pq__"